module.exports = __webpack_public_path__ + "img/section5.d62adb42.jpg";